<template>

  <div class="container-fluid">


    <h4>مواد اولیه بر اساس : </h4>
    <b-tabs justified
            active-nav-item-class="font-weight-bold text-success"
            active-tab-class="font-weight-bold"
            content-class="">
      <!--------first tab------->
      <b-tab title="بازه تاریخی" active>
        <div class="row m-2">
          <div class="input-group">
            <h5 class="mt-2">موجودی مواد اولیه در بازه </h5>
            <div class="input-group-prepend custom">
              <div class="input-group-text ml-3 h-100">
                <i class="icon-calendar-blank-outline"></i>
                <span> از تاریخ </span>
              </div>
              <date-picker
                v-show=true
                :auto-submit="true"
                format="jYYYY-jMM-jDD"
                @input="setDateFromDatePicker"
                ref="datePicker1"
              >
                <slot>
                  <input
                    :readonly=true
                    v-model="startPlanningDateJ"
                    class="form-control date-input"
                    @click="toggleStartPlanningDatePicker"
                  >
                </slot>
              </date-picker>
              <div class="input-group-text ml-3 h-100">
                <i class="icon-calendar-blank-outline"></i>
                <span> تا تاریخ </span>
              </div>
              <date-picker
                v-show=true
                :auto-submit="true"
                format="jYYYY-jMM-jDD"
                @input="setDateFromDatePicker"
                ref="datePicker2"
              >
                <slot>
                  <input
                    :readonly=true
                    v-model="endPlanningDateJ"
                    class="form-control date-input"
                    @click="toggleEndPlanningDatePicker"
                  >
                </slot>
              </date-picker>
            </div>

          </div>
        </div>
        <div v-if="isLoading" class="col-12 my-2 text-center">
          <Preloader/>
        </div>
        <div v-else>
          <div class="row my-2 text-center" v-if="nodataDate">
            <div class="col-12 mt-3">
              <h5>موجودی ثبت نشده است</h5>

            </div>
          </div>
          <div class="row my-2" v-else>
            <div class="col-12 mt-3">
              <table class="table table-striped">
                <thead>
                <tr>
                  <th scope="col" class="text-center">نام محصول</th>
                  <th scope="col" class="text-center">واحد</th>
                  <th scope="col" class="text-center">کارگاه ها</th>
                  <th scope="col" class="text-center">موجودی سایر کارگاه ها</th>

                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, indexDate) in dateQuantity">

                  <td class="text-center">{{item.name}}</td>
                  <td class="text-center">{{item.unitName}}</td>
                  <td class="text-center">
                    <table class="table table-striped">
                      <thead>
                      <tr>
                        <th scope="col" class="text-center">نام کارگاه در الگوی تولید</th>
                        <th scope="col" class="text-center">موجودی</th>
                        <th scope="col" class="text-center">نیاز</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(ite, indexcompanyNeed) in item.companyNeedQuantitys">
                        <td class="text-center">{{ite.companyName}}</td>
                        <td class="text-center">{{ite.totalQuantity<0? "("+ ite.totalQuantity*-1+"-)":ite.totalQuantity}}</td>
                        <td class="text-center">{{ite.totalNeed}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </td>
                  <td v-if="item.companyQuantitys == null">
                    <h6 class="text-center">موجودی ثبت نشده است</h6>
                  </td>
                  <td v-else>
                    <table class="table table-striped">
                      <thead>
                      <tr>
                        <th scope="col" class="text-center">نام کارگاه</th>
                        <th scope="col" class="text-center">موجودی انبار</th>
                        <th scope="col" class="text-center">انتقال به کارگاه الگو</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(it, indexQuantity) in item.companyQuantitys">
                        <td class="text-center">{{it.companyName}}</td>
                        <td class="text-center">{{it.quantity}}</td>
                        <td class="text-center">
                          <button class="btn iconed btn-secondary"
                                  @click="onTransferClicked2(indexDate,indexQuantity,dateQuantity)"><i
                            class="icon-content-duplicate"></i><span>انتقال</span></button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </td>

                </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </b-tab>
      <!--------first tab------->
      <b-tab title="برنامه تولید">
        <div class="row m-2">
          <h5>مواد اولیه بکار رفته در برنامه تولید</h5>

          <div class="col-11">
            <div class="input-group">
              <div class="input-group-prepend custom">
                <div class="input-group-text">
                  <span>موجودی مواد اولیه بر اساس برنامه تولید</span>
                </div>
              </div>
              <vs-select
                ref="selectedProgram"
                :isHeader="true"
                :data="programCodes"
                :selectedVal="programCodes.programId"
                :header="{label:'name'}"
                :mode="'edit'"
                @dataChanged="programSelect"
                aria-placeholder="لطفا برنامه را انتخاب کنید"
              ></vs-select>
              <!--v-bind:class="{ 'hover-pointer': mode!=='view' }"-->
            </div>
          </div>
        </div>
        <div class="row my-2 text-center" v-if="nodataProgram">
          <div class="col-12 mt-3">
            <h5>موجودی ثبت نشده است</h5>

          </div>
        </div>
        <div class="row my-2" v-else>
          <div class="col-12 mt-3">
            <table class="table table-striped">
              <thead>
              <tr>
                <th scope="col" class="text-center">نام محصول</th>
                <th scope="col" class="text-center">واحد</th>
                <th scope="col" class="text-center">نام کارگاه در الگوی تولید</th>
                <th scope="col" class="text-center">موجودی انبار کارگاه الگوی تولید</th>
                <th scope="col" class="text-center">تعداد مورد نیاز برای این برنامه</th>
                <th scope="col" class="text-center">موجودی در سایر انبارها</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, indexprogram) in programQuantity">

                <td class="text-center">{{item.name}}</td>
                <td class="text-center">{{item.unitName}}</td>
                <td class="text-center">{{item.companyName}}</td>
                <td class="text-center">{{item.totalQuantity<0?"("+item.totalQuantity*-1+"-)":item.totalQuantity}}</td>
                <td class="text-center">{{item.totalNeed}}</td>
                <td v-if="item.companyQuantitys == null">
                  <h6 class="text-center">موجودی ثبت نشده است</h6>
                </td>
                <td v-else>
                  <table class="table table-striped">
                    <thead>
                    <tr>
                      <th scope="col" class="text-center">نام کارگاه</th>
                      <th scope="col" class="text-center">موجودی انبار</th>
                      <th scope="col" class="text-center">انتقال به کارگاه الگو</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(it, indexcompany) in item.companyQuantitys">
                      <td class="text-center">{{it.companyName}}</td>
                      <td class="text-center">{{it.quantity}}</td>
                      <td class="text-center">
                        <button class="btn iconed btn-secondary"
                                @click="onTransferClicked(indexprogram,indexcompany,programQuantity)"><i
                          class="icon-content-duplicate"></i><span>انتقال</span></button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </td>

              </tr>
              </tbody>
            </table>
          </div>

        </div>

      </b-tab>
      <!--------second tab------->

      <b-tab title="کار">
        <div class="row m-2">
          <h5 class="col-12">مواد اولیه بکار رفته در کار</h5>
          <div class="col-11">
            <div class="input-group">
              <div class="input-group-prepend custom">
                <div class="input-group-text">
                  <span>موجودی مواد اولیه بر اساس کد کار</span>
                </div>
              </div>
              <vs-select
                ref="selectedProgram"
                :isHeader="true"
                :data="workCodes"
                :selectedVal="workCodes.id"
                :header="{label:'name'}"
                :mode="'edit'"
                @dataChanged="workSelect"
                aria-placeholder="لطفا کد کار را انتخاب کنید"
              ></vs-select>
              <!--v-bind:class="{ 'hover-pointer': mode!=='view' }"-->
            </div>
          </div>
        </div>
        <div class="row my-2 text-center" v-if="nodataWork">
          <div class="col-12 mt-3">
            <h5>موجودی ثبت نشده است</h5>

          </div>
        </div>
        <div class="row my-2" v-else>
          <div class="col-12 mt-3">
            <table class="table table-striped">
              <thead>
              <tr>
                <th scope="col" class="text-center">نام محصول</th>
                <th scope="col" class="text-center">واحد</th>
                <th scope="col" class="text-center">نام کارگاه در الگوی تولید</th>
                <th scope="col" class="text-center">موجودی انبار کارگاه الگوی تولید</th>
                <th scope="col" class="text-center">تعداد مورد نیاز برای این کار</th>
                <th scope="col" class="text-center">موجودی در سایر انبارها</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, workindex) in workQuantity">

                <td class="text-center">{{item.name}}</td>
                <td class="text-center">{{item.unitName}}</td>
                <td class="text-center">{{item.companyName}}</td>
                <td class="text-center">{{item.totalQuantity<0?"("+item.totalQuantity*-1+"-)":item.totalQuantity}}</td>
                <td class="text-center">{{item.totalNeed}}</td>
                <td v-if="item.companyQuantitys == null">
                  <h6 class="text-center">موجودی ثبت نشده است</h6>
                </td>
                <td v-else>
                  <table class="table table-striped">
                    <thead>
                    <tr>
                      <th scope="col" class="text-center">نام کارگاه</th>
                      <th scope="col" class="text-center">موجودی انبار</th>
                      <th scope="col" class="text-center">انتقال به کارگاه الگو</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(it, copmanyindex) in item.companyQuantitys">
                      <td class="text-center">{{it.companyName}}</td>
                      <td class="text-center">{{it.quantity}}</td>
                      <td class="text-center">
                        <button class="btn iconed btn-secondary"
                                @click="onTransferClicked(workindex,copmanyindex,workQuantity)"><i
                          class="icon-content-duplicate"></i><span>انتقال</span></button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </td>

              </tr>
              </tbody>
            </table>
          </div>

        </div>


      </b-tab>

      <!--&lt;!&ndash;&#45;&#45;&#45;&#45;&#45;&#45;third tab-&#45;&#45;&#45;&#45;&ndash;&gt;-->
      <!--<b-tab title="دستور تولید">-->
      <!--<div class="row m-2">-->
      <!--<h5 class="col-12">مواد اولیه بکار رفته در دستور تولید</h5>-->
      <!--<div class="col-11">-->
      <!--<div class="input-group">-->
      <!--<div class="input-group-prepend custom">-->
      <!--<div class="input-group-text">-->
      <!--<span>موجودی مواد اولیه بر اساس کد دستور تولید</span>-->
      <!--</div>-->
      <!--</div>-->
      <!--<vs-select-->
      <!--ref="selectedProgram"-->
      <!--:isHeader="true"-->
      <!--:data="orderCodes"-->
      <!--:selectedVal="orderCodes.id"-->
      <!--:header="{label:'namee'}"-->
      <!--:mode="'edit'"-->
      <!--@dataChanged="orderSelect"-->
      <!--aria-placeholder="لطفا کد دستور تولید را انتخاب کنید"-->
      <!--&gt;</vs-select>-->
      <!--&lt;!&ndash;v-bind:class="{ 'hover-pointer': mode!=='view' }"&ndash;&gt;-->
      <!--</div>-->
      <!--</div>-->
      <!--</div>-->
      <!--<div class="row my-2 text-center" v-if="nodataOrder">-->
      <!--<div class="col-12 mt-3">-->
      <!--<h5>موجودی ثبت نشده است</h5>-->

      <!--</div>-->
      <!--</div>-->
      <!--<div class="row my-2" v-else>-->
      <!--<div class="col-12 mt-3">-->
      <!--<table class="table table-striped">-->
      <!--<thead>-->
      <!--<tr>-->
      <!--<th scope="col" class="text-center">نام محصول</th>-->
      <!--<th scope="col" class="text-center">واحد</th>-->
      <!--<th scope="col" class="text-center">نام کارگاه در الگوی تولید</th>-->
      <!--<th scope="col" class="text-center">موجودی انبار کارگاه الگوی تولید</th>-->
      <!--<th scope="col" class="text-center">تعداد مورد نیاز برای این برنامه</th>-->
      <!--<th scope="col" class="text-center">موجودی در سایر انبارها</th>-->
      <!--</tr>-->
      <!--</thead>-->
      <!--<tbody>-->
      <!--<tr v-for="(item, workindex) in orderQuantity">-->

      <!--<td class="text-center">{{item.name}}</td>-->
      <!--<td class="text-center">{{item.unitName}}</td>-->
      <!--<td class="text-center">{{item.companyName}}</td>-->
      <!--<td class="text-center">{{item.totalQuantity}}</td>-->
      <!--<td class="text-center">{{item.totalNeed}}</td>-->
      <!--<td v-if="item.companyQuantitys == null">-->
      <!--<h6 class="text-center">موجودی ثبت نشده است</h6>-->
      <!--</td>-->
      <!--<td v-else>-->
      <!--<table class="table table-striped">-->
      <!--<thead>-->
      <!--<tr>-->
      <!--<th scope="col" class="text-center">نام کارگاه</th>-->
      <!--<th scope="col" class="text-center">موجودی انبار</th>-->
      <!--<th scope="col" class="text-center">انتقال به کارگاه الگو</th>-->
      <!--</tr>-->
      <!--</thead>-->
      <!--<tbody>-->
      <!--<tr v-for="(it, copmanyindex) in item.companyQuantitys">-->
      <!--<td class="text-center">{{it.companyName}}</td>-->
      <!--<td class="text-center">{{it.quantity}}</td>-->
      <!--<td class="text-center">-->
      <!--<button class="btn iconed btn-secondary"-->
      <!--@click="onTransferClicked(workindex,copmanyindex,orderQuantity)"><i-->
      <!--class="icon-content-duplicate"></i><span>انتقال</span></button>-->
      <!--</td>-->
      <!--</tr>-->
      <!--</tbody>-->
      <!--</table>-->
      <!--</td>-->

      <!--</tr>-->
      <!--</tbody>-->
      <!--</table>-->
      <!--</div>-->

      <!--</div>-->


      <!--</b-tab>-->
    </b-tabs>


    <!------------------- MODALS ------------------------------------------------------------->
    <b-modal
      ref="transferModal"
      title="انتقال به کارگاه مورد نیاز"
      size="lg"
      ok-only
      ok-title="تایید"
      @ok="transferToWorkstation"
    >
      <div class="row">
        <div class="col-12">
          <label>
            تائید انتقال کالای
            <b>{{trsfProduct}}</b>
            از کارگاه
            <b>{{trsfServe}}</b>
            به کارگاه
            <b>{{trsfRecive}}</b>
          </label>
        </div>
        <div class="col-12 my-3">
          <label>
            تعداد :
            <small>
              *توجه : تعداد قابل انتقال
              {{trsfMaxCount}}
              عدد میباشد
            </small>
          </label>
          <input class="mx-2" v-model="trsfCount" type="number" placeholder="تعداد را وارد کنید"/>
        </div>

      </div>
    </b-modal>
    <b-modal
      ref="transferModal2"
      title="انتقال به کارگاه مورد نیاز"
      size="lg"
      ok-only
      ok-title="تایید"
      @ok="transferToWorkstation"
    >
      <div class="row input-group">
        <div class="col-12 input-group">
          <div class="input-group">
            <label>
              تائید انتقال کالای
              <b>{{trsfProduct}}</b>
              از کارگاه
              <b>{{trsfServe}}</b>
              به کارگاه
            </label>
          </div>
          <div class="input-group-prepend custom d-inline">
            <vs-select
              ref="selectCompany"
              :data="companyList"
              :header="{label:'companyName'}"
              :mode="'edit'"
              :is-header="true"
              :selected-val="companyList.companyId"
              @dataChanged="companySelect"
              class="d-inline-block"
            ></vs-select>
          </div>

        </div>
        <div class="col-12 my-3">
          <label>
            تعداد :
            <small>
              *توجه : تعداد قابل انتقال
              {{trsfMaxCount}}
              عدد میباشد
            </small>
          </label>
          <input class="mx-2" v-model="trsfCount" type="number" placeholder="تعداد را وارد کنید"/>
        </div>

      </div>
    </b-modal>
    <!-------------------------------------------------------------------------------->

  </div>
</template>

<script>
  import VsTable from "../../_framework/VsTable.vue";
  import BaseService from "../../_framework/api/BaseService.js";
  import Vue from "vue";
  import Products from "../Products.vue";
  import VsSelect from "../../_framework/VsSelect";
  import DatePicker from "../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue";
  import Moment from "moment-jalali";
  import Utils from "../../_framework/utils/Utils";


  export default {
    name: "raw-planning",
    created: () => {
    },
    components: {
      VsTable,
      Products,
      VsSelect,
      Moment,
      datePicker: DatePicker,
    },
    data() {
      return {
        isLoading: false,
        show: true,
        nodataProgram: true,
        nodataWork: true,
        nodataOrder: true,
        nodataDate: true,
        access: {},
        product: {},
        programQuantity: [],
        productName: "",
        productId: "",
        rawproductQuantity: {},
        rawproducts: {},
        programCodes: [],
        workCodes: [],
        workQuantity: [],
        orderCodes: [],
        orderQuantity: [],
        dateQuantity: [],
        endPlanningDateJ: null,
        endPlanningDate: null,
        startPlanningDateJ: null,
        startPlanningDate: null,
        documentTypeId: 0,
        trsfProduct: "",
        trsfProductId: 0,
        trsfServe: "",
        trsfServeId: 0,
        trsfRecive: "",
        trsfReciveId: 0,
        trsfMaxCount: 0,
        trsfCount: 0,
        trsfPrice: 0,

        companyList: [],


      };
    },
    beforeMount() {
      // this.getAllRawProductsQuantity();
      this.getAllProgramCode();
      this.getAllWorks();
      this.getDocumentTypes();
    },
    methods: {
      openProductModal() {

        let ComponentClass = Vue.extend(Products);
        let _products = new ComponentClass({
          propsData: {isSelectMode: "true"},
          store: this.$store
        });
        _products.$mount();

        if (this.$refs && this.$refs.selectProductModal) {


          this.$refs.selectProductModal.show();
        }
        _products.$on("onRowSelect", row => {
          // this.selectProduct(row);
        });
        _products.$on("onRowDoubleClicked", row => {
          this.onSelectProductOk(row);
        });
      },
      onSelectProductOk(row) {
        this.hideModal();
      },
      openProductDetailModal(prod) {
        this.productName = prod.productName;
        this.productId = prod.id;
        this.hideModal();
        this.getAllProductsQuantity(prod.id)
        // new BaseService('Patterns', '/GetProductPatterns/' + prod.id).getList().then((response) => {
        //   var a = response.data;
        //
        //   if (a.length === 0) {
        //     Utils.handleErrorWithNotification("هیچ الگویی برای این کالا تعریف نشده است", this.$noty);
        //   } else {
        //     this.product = prod;
        //     this.productId = prod.id;
        //     this.names = response.data;
        //     this.productPattern = response.data;
        //     console.log(this.productPattern);
        //     this.showPlanningModal = true;
        //     this.$refs.selectProductModal.hide();
        //     this.getPatterns();
        //   }
        // }).catch((error) => {
        //   console.log(error)
        // })
        // this.getKardex(val.id);
      },
      getAllProductsQuantity(id) {
        new BaseService('Planning', '/GetAllProductsQuantity/' + id).getList().then((response) => {
          if (response.data === null || response.data == "") {
            this.nodataProgram = true;
          } else {
            this.nodataProgram = false;
            this.productQuantity = response.data;
          }
        }).catch((error) => {
          console.log(error)
        });
      },
      getAllProgramCode() {
        this.isLoading = true;
        new BaseService('Planning', '/GetAllProgramCode').getList().then((response) => {
          this.programCodes = response.data;
          if (this.programCodes.length > 0) {
            for (let i = 0; i < this.programCodes.length; i++) {
              this.programCodes[i].name = "برنامه کد " + this.programCodes[i].programCode + " کالای " + this.programCodes[i].productName + " تعداد " + this.programCodes[i].count + " باقیمانده " + (this.programCodes[i].count - this.programCodes[i].completed);
            }
          }
          this.isLoading = false;
        }).catch((error) => {
          this.isLoading = false;
          console.log(error)
        });
      },
      getAllWorks() {
        this.isLoading = true;
        new BaseService('Works', '/GetAllWorks/' + 0 + '/' + 10000 + '/' + false).getList().then((response) => {
          this.workCodes = response.data.data;
          if (this.workCodes.length > 0) {
            for (let i = 0; i < this.workCodes.length; i++) {
              let find = false;
              let count = 0;
              let index = 0;
              if (this.workCodes[i].productOrderCode == null) {
                this.workCodes[i].name = "کار کد " + this.workCodes[i].code + " کالای " + this.workCodes[i].productName + " کد سفارش " + this.workCodes[i].orderCode;
              } else {
                this.workCodes[i].name = "کار کد " + this.workCodes[i].code + " کالای " + this.workCodes[i].productName + " کد برنامه " + this.workCodes[i].productOrderCode;
              }
              for (let j = 0; j < this.orderCodes.length; j++) {
                if (this.workCodes[i].productOrderCode != null) {
                  if (this.workCodes[i].productOrderCode === this.orderCodes[j].productOrderCode) {
                    find = true;
                    count++;
                    index = j;
                  }
                } else {
                  if (this.workCodes[i].orderCode === this.orderCodes[j].orderCode) {
                    find = true;
                    count++;
                    index = j;
                  }
                }
              }
              if (!find) {
                this.orderCodes.push(this.workCodes[i]);
                this.orderCodes[this.orderCodes.length - 1].count = 1;
              } else {
                this.orderCodes[index].count += count;
              }
            }
            for (let j = 0; j < this.orderCodes.length; j++) {
              if (this.orderCodes[j].productOrderCode == null) {
                this.orderCodes[j].namee = "کالای " + this.orderCodes[j].productName + " کد سفارش " + this.orderCodes[j].orderCode + " تعداد " + this.orderCodes[j].count;
              } else {
                this.orderCodes[j].namee = "کالای " + this.orderCodes[j].productName + " کد برنامه " + this.orderCodes[j].productOrderCode + " تعداد " + this.orderCodes[j].count;
              }
            }
          }
          this.isLoading = false;
        }).catch((error) => {
          this.isLoading = false;
          console.log(error)
        });
      },
      hideModal() {
        this.$refs.transferModal.hide();
        this.$refs.transferModal2.hide();
      },
      getAllRawProductsQuantity() {
        this.isLoading = true;
        new BaseService('Planning', '/GetAllRawProductsQuantity').getList().then((response) => {
          this.rawproductQuantity = response.data;
          this.isLoading = false;
        }).catch((error) => {
          this.isLoading = false;
          console.log(error)
        });
      },
      programSelect(prop, data) {
        this.isLoading = true;
        this.productTypesId = data.id;
        new BaseService('Planning', '/GetRawProductFromProgramCode/' + data.programId + '/' + data.productId).getList().then((response) => {
          if (response.data === null || response.data == "") {
            this.nodataProgram = true;
          } else {
            this.nodataProgram = false;
            this.programQuantity = response.data;
          }
          this.isLoading = false;
        }).catch((error) => {
          this.isLoading = false;
          Utils.handleErrorWithNotification("لیست وقفه پیدا نشد", this.$noty);
          console.log(error)
        });
      },
      workSelect(prop, data) {
        this.isLoading = true;
        new BaseService('Planning', '/GetRawProductFromWork/' + data.id).getList().then((response) => {
          if (response.data === null || response.data == "") {
            this.nodataWork = true;
          } else {
            this.nodataWork = false;
            this.workQuantity = response.data;
          }
          this.isLoading = false;
        }).catch((error) => {
          this.isLoading = false;
          Utils.handleErrorWithNotification("لیست وقفه پیدا نشد", this.$noty);
          console.log(error)
        });
      },
      orderSelect(prop, data) {
        this.isLoading = true;
        new BaseService('Planning', '/GetRawProductFromWork/' + data.id).getList().then((response) => {
          if (response.data === null || response.data == "") {
            this.nodataOrder = true;
          } else {
            this.nodataOrder = false;
            this.orderQuantity = response.data;
            for (let i = 0; i < this.orderQuantity.length; i++) {
              this.orderQuantity[i].totalNeed = this.orderQuantity[i].totalNeed * data.count;
            }
          }
          this.isLoading = false;
        }).catch((error) => {
          this.isLoading = false;
          Utils.handleErrorWithNotification("لیست وقفه پیدا نشد", this.$noty);
          console.log(error)
        });
      },
      setDateFromDatePicker(date) {
        if (this.dateClicked === 1) {
          this.startPlanningDateJ = date;
          let sdate = Moment(date, "jYYYY/jMM/jDD");
          this.startPlanningDate = sdate.format("YYYY-MM-DD");
        }
        if (this.dateClicked === 2) {
          this.endPlanningDateJ = date;
          let sdate = Moment(date, "jYYYY/jMM/jDD");
          this.endPlanningDate = sdate.format("YYYY-MM-DD");
          this.getDatePlanning(this.startPlanningDate, this.endPlanningDate);
        }
      },
      toggleStartPlanningDatePicker() {
        this.dateClicked = 1;
        this.$refs.datePicker1.togglePicker();
      },
      toggleEndPlanningDatePicker() {
        this.dateClicked = 2;
        this.$refs.datePicker2.togglePicker();
      },
      getDatePlanning(start, end) {
        let createTimesheet = {
          startDate: start,
          endDate: end
        };
        // console.log(createTimesheet);
        this.isLoading = true;
        new BaseService('Planning', '/GetRawProductFromDate').create(createTimesheet).then((response) => {
            this.dateQuantity = response.data;
            if (this.dateQuantity.length > 0) {
              this.nodataDate = false;
            } else {
              this.nodataDate = true;
            }
            this.isLoading = false;
          }
        ).catch((error) => {
          this.isLoading = false;
          console.log(error)
        })
      },
      getDocumentTypes() {
        new BaseService('documentTypes').getList().then((response) => {
            let ducTypes = response.data;
            let find = false;
            let index = 0;
            for (let i = 0; i < ducTypes.length; i++) {
              if (ducTypes[i].name === 'انتقال به کارگاه دیگر') {
                find = true;
                index = i;
                break;
              }
            }
            if (find) {
              this.documentTypeId = ducTypes[index].id;
            } else {
              let data = {
                name: 'انتقال به کارگاه دیگر',
                type: 2
              };
              new BaseService('documentTypes').create(data).then((response) => {
                  // g(response.data);
                  this.documentTypeId = response.data.id;
                }
              ).catch((error) => {
                console.log(error)
              })
            }

          }
        ).catch((error) => {
          console.log(error)
        })
      },
      transferToWorkstation() {
        if (this.trsfCount == 0) {
          Utils.handleErrorWithNotification("تعداد انتقالی نمیتواند صفر باشد", this.$noty);
        } else if (this.trsfCount > this.trsfMaxCount) {
          Utils.handleErrorWithNotification("تعداد انتقالی نمیتواند از موجودی بیشتر باشد", this.$noty);
        } else {
          this.hideModal();
          let todayDate = new Date();

          todayDate = new Date().toJSON().slice(0, 10);

          let data = {
            description: "انتقال به انبار کارگاه دیگر",
            documentTypeId: this.documentTypeId,
            receiveOutSourceId: null,
            receiverCompanyId: this.trsfReciveId,
            serveCompanyId: this.trsfServeId,
            serveOutSourceId: null,
            voucherDate: todayDate,
            voucherProductDto: [{
              productId: this.trsfProductId,
              unitVal: this.trsfCount,
              price: this.trsfPrice,
              productName: this.trsfProduct,

            }],
          };

          new BaseService('voucher').create(data).then((response) => {
              this.$noty.success("انتقال با موفقیت انجام شد");

            }
          ).catch((error) => {
            console.log(error)
          })

        }
      },
      onTransferClicked(workIndex, companyIndex, source) {
        this.trsfProduct = source[workIndex].name;
        this.trsfProductId = source[workIndex].productId;
        this.trsfRecive = source[workIndex].companyName;
        this.trsfReciveId = source[workIndex].companyId;
        this.trsfServe = source[workIndex].companyQuantitys[companyIndex].companyName;
        this.trsfServeId = source[workIndex].companyQuantitys[companyIndex].companyId;
        this.trsfMaxCount = source[workIndex].companyQuantitys[companyIndex].quantity;
        this.trsfPrice = source[workIndex].companyQuantitys[companyIndex].price;
        this.$refs.transferModal.show();
      },
      onTransferClicked2(workIndex, indexQuantity, source) {
        this.trsfProduct = source[workIndex].name;
        this.trsfProductId = source[workIndex].productId;
        // this.trsfRecive = source[workIndex].companyName;
        // this.trsfReciveId = source[workIndex].companyId;
        this.trsfServe = source[workIndex].companyQuantitys[indexQuantity].companyName;
        this.trsfServeId = source[workIndex].companyQuantitys[indexQuantity].companyId;
        this.trsfMaxCount = source[workIndex].companyQuantitys[indexQuantity].quantity;
        this.trsfPrice = source[workIndex].companyQuantitys[indexQuantity].price;
        this.companyList = source[workIndex].companyNeedQuantitys;

        this.$refs.transferModal2.show();
      },
      companySelect(prop, data) {
        this.trsfRecive = data.companyName;
        this.trsfReciveId = data.companyId;
      },


    },
  };
</script>
